// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IconSpinner_root__XZz8H {
  /* While the viewbox of the icon is 30x30, the icon size is scaled to
   28x28 by default, which results in scaling the whole image and the
   strokes a bit.*/
  width: 28px;
  height: 28px;
  stroke: var(--marketplaceColor);
  stroke-width: 3px;
}`, "",{"version":3,"sources":["webpack://./src/components/IconSpinner/IconSpinner.module.scss"],"names":[],"mappings":"AAAA;EACI;;kBAAA;EAGA,WAAA;EACA,YAAA;EAEA,+BAAA;EACA,iBAAA;AAAJ","sourcesContent":[".root {\n    /* While the viewbox of the icon is 30x30, the icon size is scaled to\n     28x28 by default, which results in scaling the whole image and the\n     strokes a bit.*/\n    width: 28px;\n    height: 28px;\n  \n    stroke: var(--marketplaceColor);\n    stroke-width: 3px;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `IconSpinner_root__XZz8H`
};
export default ___CSS_LOADER_EXPORT___;
